// No iframe version
// import React from 'react';
// import { render } from 'react-dom';
// import App from './App';
import { iframeResizer } from 'iframe-resizer';

const getElement = elOrId => {
  if (!elOrId) throw Error('Element or an id if required');
  if (typeof elOrId === 'string') {
    const id = elOrId.replace('#', '');
    const div = document.getElementById(id);
    if (!div) throw Error("Couldn't find an element with id:" + id);
    return div;
  }
  return elOrId;
};

// No iframe version
// const getRenderer = elOrId => (Component, props) => {
//   const div = getElement(elOrId);
//   render(
//     // Use a provider if adding redux
//     // <Provider store={store}>
//     <Component {...props} />,
//     // </Provider>,
//     div
//   );
// };

// const createEmbed = (elOrId, options) => {
//   const renderer = getRenderer(elOrId);
//   renderer(App, options);
// };

const createEmbed = (id, options) => {
  var div = getElement(id);
  var iframe = document.createElement('iframe');
  iframe.scrolling = 'no';
  iframe.style.width = '100%';
  iframe.style.border = 'none';
  div.appendChild(iframe);

  const url = `${
    process.env.PUBLIC_URL
      ? process.env.PUBLIC_URL
      : 'https://embed-example.visualise.today'
  }`;
  iframe.src = url;
  iframe.onload = () => {
    iframeResizer({ log: false }, iframe);
  };
};

window._smuCreateEmbed = createEmbed;



// WEBPACK FOOTER //
// ./src/create-embed.js